<template>
  <div
    class="fixed inset-0 w-full min-h-screen z-loading-screen papsi-loading-screen flex flex-col"
  >
    <div class="flex-1 flex flex-col items-center justify-center">
      <img
        class="papsi-mascot w-logo h-logo mx-auto mb-5"
        :src="getKalabaw()"
      />
      <div class="text-primary text-xl font-bold flex items-center">
        <p>{{ lang("lbl_0000214") }}</p>
        <span class="dots-container">
          <span class="dots"></span>
        </span>
      </div>
    </div>

    <div class="text-grey-dark text-xs text-center mb-4">
      {{ this.version }}
    </div>
  </div>
</template>

<script>
import mixin from "./../../mixin.js";

export default {
  mixins: [mixin],
  props: {
    loading: {
      type: Boolean,
    },
  },
  data() {
    return {
      image: "",
      version: "",
    };
  },
  mounted() {
    this.version = this.lang("lbl_0000044") + " " + process.env.VUE_APP_VERSION;
    this.image = this.getMediaPath("/logo/papsi-mobile.jpg");
  },
  methods: {
    getKalabaw() {
      const path = "pia/images/elements/";
      const file_name = "papsi_kalabaw.png";
      if (process.env.VUE_APP_CDN_URL) {
        return process.env.VUE_APP_CDN_URL + path + file_name;
      }
    },
  },
};
</script>

<style scoped>
@keyframes mascot-wave {
  0%,
  100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-20px);
  }
}

.papsi-loading-screen {
  background: radial-gradient(
    circle,
    rgba(229, 231, 235, 1) 10%,
    rgb(149, 155, 167) 100%
  );
}

.papsi-mascot {
  animation: mascot-wave 1s ease-in-out infinite;
  transform-origin: top center;
}

.dots-container {
  display: inline-block;
  text-align: left;
}

@keyframes dot-blink {
  0% {
    content: "";
  }
  25% {
    content: ".";
  }
  50% {
    content: "..";
  }
  75% {
    content: "...";
  }
  100% {
    content: "";
  }
}

.dots::after {
  animation: dot-blink 2s steps(4, end) infinite;
  content: ""; 
}
</style>
